import { create } from "zustand";

interface CpfState {
  cpf: string;
  setCpf: (cpf: string) => void;
}

export const useCpf = create<CpfState>((set) => ({
  cpf: '',
  setCpf: (cpf) => set({ cpf })
}));
